import { Swiper } from 'swiper';
import Scrolling from '../modules/utils/class/scrolling';
import Cookies from '../modules/utils/class/cookies';

import ProjectsFilterForm from '../modules/forms/projects/filter';
import ProjectSharing from '../modules/components/projects/sharing';
import ProjectCloseForm from '../modules/forms/projects/close';
import ProjectInvitationForm from '../modules/forms/projects/invitation';
import ProjectMobileFilter from '../modules/components/projects/mobile-filter';
import ProjectCheckboxDropdown from '../modules/components/projects/checkbox-dropdown';

import ProjectAdminPanel from '../modules/components/projects/admin-panel';

export default function setProjectsScripts () {
    if (
        !window.location.pathname.includes('/projects/') ||
        window.location.pathname.includes('/dashboard/') ||
        window.location.pathname.includes('/user/')
    ) return;

    const path = window.location.pathname;

    const routes = {
        listing: () => path === '/projects/',
        single: () => path.split('/').length > 3
    };

    if (!Object.values(routes).some((route) => route())) return;

    // Sharing

    if (routes.single()) {
        new ProjectSharing();

        ['DOMContentLoaded', 'resize', 'orientationchange'].forEach((event) => {
            window.addEventListener(event, () => {
                const aside = document.querySelector('.site-project__aside');
                const mobile = document.querySelector('#mobile-aside-placement');
                const desktop = document.querySelector('#desktop-aside-placement');

                if (window.innerWidth <= 991) {
                    mobile.append(aside);
                } else {
                    desktop.append(aside);
                }
            });
        });

        new ProjectAdminPanel();
    }

    // Forms

    if (routes.listing()) {
        new ProjectsFilterForm('#projects-filter-form');

        ProjectMobileFilter();
        ProjectCheckboxDropdown();
    }

    if (routes.single()) {
        if (document.querySelector('#close-project-form')) new ProjectCloseForm('#close-project-form');
        if (document.querySelector('#invitation-form')) new ProjectInvitationForm('#invitation-form');
    }

    // Popup

    if (routes.single()) {
        const cookies = new Cookies();

        const scrolling = new Scrolling();

        const showPopup = (popup, inner, slider) => {
            scrolling.disable();
        
            popup.classList.add('visible');
        
            slider.slideTo(0);
        
            setTimeout(() => {
                inner.classList.add('animated');
            }, 150);
        }
        
        const hidePopup = (popup, inner) => {
            cookies.setProperty('pp_how_it_works', '/', true);

            inner.classList.remove('animated');
        
            setTimeout(() => {
                popup.classList.remove('visible');
        
                scrolling.enable();
            }, 300);
        }
        
        const changeStep = (key, slider) => {
            slider.slideTo(key);
        }

        const popup = document.querySelector('#popup-single-project');

        if (!popup) return;
        
        const slider = new Swiper('.popup-project__steps', {
            slidesPerView: 1,
            allowTouchMove: false,
            spaceBetween: 40
        });
        
        const inner = popup.querySelector('.popup-project__inner');
        
        const steps = popup.querySelectorAll('.popup-project--step');
        if (!steps || !steps.length) return;

        const isClosed = cookies.getProperty('pp_how_it_works', '/');

        console.log(isClosed);
        
        if (!isClosed) showPopup(popup, inner, slider);
        
        [...steps].forEach(step => {
            const buttons = step.querySelectorAll('.popup-project--control');
            if (!buttons || !buttons.length) return;
        
            const triggers = {
                next: [...buttons].filter(button => button.dataset.target !== '0'),
                close: [...buttons].filter(button => button.dataset.target === '0')
            }
        
            triggers.next.forEach(button => {
                button.addEventListener('click', event => {
                    event.stopPropagation();
        
                    changeStep(button.dataset.target, slider);
                });
            });
        
            triggers.close.forEach(button => {
                button.addEventListener('click', event => {
                    event.stopPropagation();
        
                    hidePopup(popup, inner);
                });
            });
        });
    }
}
